import { ProtocolContentData } from "../../protocol";
export class Anchoring extends ProtocolContentData {
    anchor;
    freeText;
    constructor(anchor, freeText) {
        super();
        this.anchor = anchor;
        this.freeText = freeText;
    }
}
//# sourceMappingURL=Anchoring.js.map